import { render, staticRenderFns } from "./RootMenu.vue?vue&type=template&id=bb20fe4e"
import script from "./RootMenu.vue?vue&type=script&lang=js"
export * from "./RootMenu.vue?vue&type=script&lang=js"
import style0 from "./RootMenu.vue?vue&type=style&index=0&id=bb20fe4e&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports